import React from "react";
import { OrdersTable } from "../../Components/Organisms";
import "./style.css";
import { Button } from "@chakra-ui/react";
import { ArrowRightIcon } from "../../Assets/images/svgs";
import { useNavigate } from "react-router-dom";
import PATHS from "../../Routes/paths";

const OrderHistory = ({ order }) => {
  const navigate = useNavigate();
  const handleViewAll = () => {
    if (order) navigate(`${PATHS.ORDERS_OVERVIEW}`);
    else navigate(`${PATHS.SHIPMENT_OVERVIEW}`);
  }

  return (
    <div className={`order-history ${order ? "is-order" : "is-shipment"}`}>
      <OrdersTable isDashboard={true} ellipsify={!order} hideColumn={order ? ["orderId"] : ["orderId", "orderTs"]} rowCount={4} title={order ? "Order History" : "Shipment History"} filterHeaders={true} shipment={!order} hideTableFilters={true} hideSearch={true} />
      <div className="widget-footer-wrapper">
        <Button className="view-all-orders-button" onClick={handleViewAll}>
          {`View all ${order ? "orders" : "shipments"}`}
          <ArrowRightIcon />
        </Button>
      </div>
    </div>
  )
}

export default OrderHistory
